import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=50643ff9&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50643ff9')) {
      api.createRecord('50643ff9', component.options)
    } else {
      api.reload('50643ff9', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=50643ff9&", function () {
      api.rerender('50643ff9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/campaigns/Index.vue"
export default component.exports